module.exports = __webpack_public_path__ + "static/media/chair.2806bbad.jpg";